import { MedicalTreatmentConsent, MedicalTreatmentConsentCreateCommand } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../translations';

type MedicalTreatmentConsentCreateCommandOptions = {
   patientId: number;
   onSuccess?: VoidFunction;
};

export const useMedicalTreatmentConsentCreateCommand = ({
   patientId,
   onSuccess,
}: MedicalTreatmentConsentCreateCommandOptions): UseCqrsCommandResult<MedicalTreatmentConsent, void> => {
   return useCqrsCommand<MedicalTreatmentConsent, void>(
      () => {
         const command = new MedicalTreatmentConsentCreateCommand();
         command.patientId = patientId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(
               patientConsentsAndAuthorizationsTranslationKeys.consent.consentHasBeenEntered
            );
            onSuccess?.();
         },
      }
   );
};
